import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) { return twMerge(clsx(inputs)); }

export function formatCurrency(amount: number, currency = "KES", locale = "en-KE"): string {
  const symbols: Record<string, string> = { KES: "Ksh", USD: "$", EUR: "EUR", UGX: "Ush", TZS: "Tsh" };
  const symbol = symbols[currency] ?? currency;
  const value = amount / 100;
  return `${symbol} ${new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value)}`;
}

export function formatDistance(km: number): string { return km < 1 ? `${Math.round(km * 1000)}m` : `${km.toFixed(1)}km`; }
export function formatDate(date: string, tz = "Africa/Nairobi"): string { return new Intl.DateTimeFormat("en-KE", { day: "numeric", month: "short", year: "numeric", timeZone: tz }).format(new Date(date)); }
export function formatDateTime(date: string, tz = "Africa/Nairobi"): string { return new Intl.DateTimeFormat("en-KE", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: tz }).format(new Date(date)); }
export function initials(name: string): string { return name.split(" ").map((p) => p[0]).filter(Boolean).slice(0, 2).join("").toUpperCase(); }
